/* eslint-disable react-hooks/exhaustive-deps */
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Radio,
  Typography,
  Tooltip,
  Button,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Dispatch, FC, SetStateAction, useCallback, useEffect, useMemo, useState } from "react"
import { EstruturaListagemResponse, Fileira, Grupo, ModuloListagem, ModuloPorRegiaoListagemResponse, Projeto, ProjetoCalcular, ResultadoCalculos } from "src/components/projetos/types"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import stringAvatarImg from '../../../assets/string.png'
import microinversorAvatarImg from '../../../assets/microinversor.png'
import theme from "src/theme/light"
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"
import { Add, Delete, FindInPageOutlined } from "@mui/icons-material"
import { SelectWithImageInOption } from "./containers/SelectWithImageInOption"
import SemEstrutura from '../../../assets/sem-estrutura.png'

import { setDimensionadoTabDisabledStatus, setDimensionadoTabDoneStatus } from "src/store/vendas/projetos/actions"
import { DEFAULT_PROJETO, MODULO_POTENCIA_MAXIMA_ATTR, MODULO_POTENCIA_MINIMA_ATTR, NOVO_PROJETO_ENGENHARIA, POSICAO_MODULO, POTENCIA_MINIMA_ENGENHARIA, TIPO_INVERSOR_ID } from "src/components/projetos/constants"
import { ProjetosProvider } from "src/providers/ProjetosProvider"
import { formState$, modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store"
import { useHistory } from "react-router-dom"
import { redirecionarParaProjetoVertical } from "src/components/projetos/utils/redirecionarParaProjetoVertical"
import { resetarProjeto } from "src/components/projetos/utils/resetarProjeto"
import { potenciaTotalMaiorQuePotenciaMaxima } from "src/components/projetos/utils/potenciaTotalMaiorQuePotenciaMaxima"
import { mostrarParametroRegiaoPotenciaAlert } from "src/components/projetos/utils/mostrarParametroRegiaoPotenciaAlert"
import { mostrarPotenciaTotalMaiorQuePotenciaMaximaAlert } from "src/components/projetos/utils/mostrarPotenciaMaiorQuePotenciaMaximaAlert"
import { LayoutProjetoDimensionado } from "../../_layouts"
import { LocalStorage } from "src/framework/commons/LocalStorage"
import { checarParametroRegiaoPotencia } from "src/components/projetos/utils/checarParametroRegiaoPotencia"
import { potenciaTotalMenorQuePotenciaMinima } from "src/components/projetos/utils/potenciaTotalMenorQuePotenciaMinima"
import { mostrarPotenciaTotalMenorQuePotenciaMinimaAlert } from "src/components/projetos/utils/mostrarPotenciaTotalMenorQuePotenciaMinimaAlert"
import { IDataResponse } from "src/framework/providers/api"
import { showPopupParceiroPowerAlert } from "src/components/projetos/utils/showPopupParceiroPowerAlert"
import { useObservable } from "src/framework/store/storeUtil"
import { fraseParceiro$ } from "src/store/global.store"
import { ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA, ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA, ALERT_POPUP_PARCEIRO, alertsList$, clearIntervalAlerts, setAlert, setAlertsList, startIntervalAlerts, stopIntervalAlerts, TAlertsDom } from "src/framework/store/ProcessarFilaMensagensStore"
import ModulosListMobile from "../../../containers/Mobile/ModulosListMobile"
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { ID_INVERSOR, ID_MICROINVERSOR } from "src/components/componentes/types";
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider";

const useStyles = makeStyles({
  restoreButtonConfirm: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    }
  },
  removeFileiraButton: {
    borderColor: theme.palette.error.light,
    color: theme.palette.error.light
  },
  addFileiraButton: {
    backgroundColor: theme.palette.warning.dark,
    color: "white",
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    }
  },
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  radioButton: {
    marginRight: 14,
  }
})

interface ModulosProps {
  formState: Projeto;
  onChangeFormState: Dispatch<SetStateAction<Projeto>>
  onClickNext: () => void;
  onClickBack: () => void;
}

const MODULO_POWER_ATTR = 'MODULO_POTENCIA'
const elSemEstrutura = { status: true, posicao: null, estruturas_grupo_id: 0, grupos: [], inversor: '', segmento: '', url_imagem: SemEstrutura, nome: 'Sem estrutura', id: 0 };

const componentesProvider = new ComponenteProvider()
const projetosProvider = new ProjetosProvider()

const Modulos: FC<ModulosProps> = ({ formState, onChangeFormState, onClickNext, onClickBack }) => {
  const classes = useStyles()
  const history = useHistory()

  const [estruturasOptions, setEstruturasOptions] = useState<EstruturaListagemResponse[]>([])
  const [estruturasCarregadas, setEstruturasCarregadas] = useState(false)

  const [projetoFiname, setProjetoFiname] = useState<boolean>(false)
  const [estruturasAjustadas, setEstruturasAjustadas] = useState(false)

  const fraseParceiroPowerAlert = useObservable(fraseParceiro$);

  const [fraseParceiroPowerAlertList] = useState<number[]>([]);

  const [fraseParceiroPowerAlertFileiraList, setFraseParceiroPowerAlertFileiraList] = useState<number[]>([]);
  const [potenciaGerador, setPotenciaGerador] = useState<number>(0);

  const [fileiraState, setFileiraState] = useState<Fileira[]>([]);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const setFormState = useCallback((newState: Partial<Projeto>) => {
    onChangeFormState(old => ({...old, ...newState}))
  },[onChangeFormState])

  const addFileira = useCallback(()=>{
    const newFileiras = [...formState.fileiras, novaFileira()]
    setFormState({ fileiras: newFileiras })
  },[formState.fileiras, setFormState])

  const removeFileira = useCallback((index: number)=>{
    const newFileiras = [...formState.fileiras]
    newFileiras.splice(index, 1)
    setFormState({ fileiras: newFileiras })
  },[formState.fileiras, setFormState])

  const metragemTotal = useMemo(()=>{
    const selected = formState.modulosList?.find(item => item.selecionado)
    if (!selected) return 0;
    return ((selected.largura / 1000) * (selected.comprimento / 1000)) * selected.quantidade
  },[formState.modulosList])

  const checkRowsDisabled = useCallback(
    (estruturaId: number) => {
      const withDisable = estruturasOptions?.find(e => e?.id === estruturaId && e?.grupos?.find((i: Grupo) => !i?.permite_fileiras))
      if (withDisable) return true;
      return false;
    },
    [estruturasOptions],
  )

  const novaFileira = useCallback((): Fileira => {
    const _formState = { ...formState }
    const _isFiname = (_formState?.modulosList?.find(item => item.selecionado)?.finame && !["personalizado"]?.includes(_formState?.tipo || "")) || false

    return {
      posicao_modulo: POSICAO_MODULO.find(pm => pm.value === 'retrato') || null,
      quantidade_modulos: 0,
      fileiras: 1,
      tipo_estrutura: _isFiname ? null : {image: elSemEstrutura.url_imagem, text: elSemEstrutura.nome, value: elSemEstrutura.id},
    }
  }, [projetoFiname, formState])

  const modulosRestantes = useMemo(()=>{
    const totalModulos = formState.fileiras.reduce((acc, item) => {
      const estruturaId = Number(item?.tipo_estrutura?.value)
      if (isNaN(estruturaId)) {
        return acc
      }
      const rowsDisabled = checkRowsDisabled(estruturaId)
      const fileiras = (!rowsDisabled ? item.fileiras : 1)
      return acc + item.quantidade_modulos * fileiras
    }, 0)
    const totalModulosSelecionados = formState.modulosList?.find(item => item.selecionado)?.quantidade || 0
    return totalModulosSelecionados - totalModulos
  },[formState.fileiras, formState.modulosList, checkRowsDisabled])

  const moduloSelecionado = useMemo(() => {
    return formState.modulosList?.find(item => item.selecionado)
  },[formState.modulosList])

  const calcularPotencia = async () : Promise<number> =>{
    if (!moduloSelecionado) return formState.potencia_desejada;
    const regioesIds = formState.regioes.map(item => item.id)

    const getValorServico = () => {
      if (!formState.recebe_servico) return 0;
      if (formState.tipo_proposta?.value === 'gerador-sem-instalacao') return 0;
      return Number(formState.valor_servico || 0)
    }

    //const recalcular = projetosProvider.confereRecalcular(componentes, formState);

    const payload = {
      componentes: [{
        altura: moduloSelecionado.altura,
        categoria_componentes_id: moduloSelecionado.categoria_componentes_id,
        componente_id: moduloSelecionado.componente_id,
        quantidade: moduloSelecionado.quantidade,
        largura: moduloSelecionado.largura,
        peso: moduloSelecionado.peso,
        potencia: moduloSelecionado.potencia,
        valor: 0,
      }],
      estado_id: formState.estado?.id || '',
      servicos: {
        valor_margem_produtos: 0,
        tipo: getValorServico() ? 'revenda' : null,
        valor: getValorServico(),
      },
      regioes: regioesIds,
      segmento: formState.segmento,
      projeto_id: formState.clonar_projeto ? undefined : (formState.id || undefined),
      distribuidor_id: formState.distribuidor?.id || undefined,
      revenda_id: formState.revenda?.id || undefined,
      recalcular: true,
    }
    const responseCalcular: IDataResponse<ResultadoCalculos> = await projetosProvider.calcular(payload as ProjetoCalcular, true);
    if(responseCalcular.statusCode === 200) {
      setPotenciaGerador(responseCalcular?.data?.componentes?.potencia_gerador)
      return responseCalcular?.data?.componentes?.potencia_gerador;
    }
    setPotenciaGerador(formState.potencia_desejada)
    return formState.potencia_desejada;
  }

  const fileirasEdicao = useMemo(() => {
    return (formState?.fileiras_edicao || []).map(fileira => {
      let fil = estruturasOptions.find(item => item.id === (fileira.tipo_estrutura?.value || 0) && item.estruturas_grupo_id === fileira.tipo_estrutura?.estruturas_grupo_id);

      const grupo = fil?.grupos?.find(grupo => grupo?.id === fileira?.tipo_estrutura?.estruturas_grupo_id );
      const _upload = LocalStorage.get("solar.uploadInfo", true);
      const imgUrl = grupo?.url_imagem && `https://${_upload?.data?.url}${grupo?.url_imagem}`;
      const posicaoCompativel = fil && fil.posicao && fileira.posicao_modulo ? ['ambos', fileira.posicao_modulo.value].includes(fil.posicao) : true;

      return {
        ...fileira,
        tipo_estrutura: fil ? {
          image: imgUrl || fil?.url_imagem,
          text: fil?.nome,
          value: fil?.id,
          estruturas_grupo_id: fil?.estruturas_grupo_id,
          exibir_popup_parceiro: fil?.exibir_popup_parceiro,
        } : null,
        fileira_invalida: !posicaoCompativel
      }
    })
  }, [formState.fileiras_edicao, estruturasOptions])

  useEffect(()=>{
    if (!moduloSelecionado) return;
    calcularPotencia().then((potencia) => {
      setPotenciaGerador(potencia)
      const tipoInversor = TIPO_INVERSOR_ID[formState.tipo_inversor?.value || 0];
      componentesProvider.buscarEstruturasPorModuloId(moduloSelecionado.componente_id, {
        potencia: String(potencia || 0),
        regiao_id: formState.regioes.map(item => item.id),
        inversor: tipoInversor || '',
        segmento: formState.segmento?.includes("on") ? "on" : "off",
      }).then(res => {
        const estruturas = res.filter(item => !!item.grupos.length && item.grupos?.map(grupo => grupo.id)?.includes(item.estruturas_grupo_id)).map(item => {
          const findGrupo = item.grupos?.find(g => g.id === item.estruturas_grupo_id) || item.grupos?.[0];
          const _upload = LocalStorage.get("solar.uploadInfo", true);
          const imgUrl = `https://${_upload?.data?.url}${item.url_imagem}`
          const imgGrupoUrl = findGrupo?.url_imagem ? `https://${_upload?.data?.url}${findGrupo.url_imagem}` : imgUrl;

          let exibir_popup_parceiro = findGrupo.componentes.some((componente: any) => componente.exibir_popup_parceiro);

          return {
            estruturas_grupo_id: item.estruturas_grupo_id,
            grupos: item.grupos?.filter(g => g?.status),
            id: item.id,
            inversor: item.inversor,
            nome: item.nome,
            segmento: item.segmento,
            url_imagem: imgGrupoUrl,
            status: (item?.status && findGrupo?.status),
            posicao: findGrupo?.posicao,
            exibir_popup_parceiro: exibir_popup_parceiro,
          }
        });

        const _formState = {...formState}
        const _isFiname = (_formState?.modulosList?.find(item => item.selecionado)?.finame && !["personalizado"]?.includes(_formState?.tipo || ""))|| false

        let _estruturas: any = estruturas;

        if (!_isFiname) {
          _estruturas = [elSemEstrutura,...estruturas];
        }

        setEstruturasOptions(_estruturas);
        setEstruturasCarregadas(true);
      })
    })
  },[moduloSelecionado, formState.potencia_desejada, formState.regioes, formState.modulosList])

  useEffect(() => {
    if (!estruturasCarregadas || estruturasAjustadas) return;
    if (!formState.fileiras.length) return;
    ajustaTipoEstrutura(estruturasOptions);
  },[formState.fileiras.length, estruturasCarregadas, estruturasOptions, estruturasAjustadas])

  useEffect(()=>{
    // Executa na edição do projeto, pois, as fileiras vem no campo `fileiras_edicao` do formState
    if (!formState.fileiras.length && formState.fileiras_edicao.length && estruturasOptions.length) {
      setFileiraState(fileirasEdicao);
      setFormState({ fileiras: fileirasEdicao, fileiras_edicao: [] })
      /*
      if(exibirMensagemParceiro && !formState.isEdit) {
        showPopupParceiroPowerAlert(fraseParceiroPowerAlert.data);
      }
      */
    }
    if (!formState.fileiras.length && !formState.fileiras_edicao.length && estruturasOptions.length && fileiraState?.length) {
      setFormState({ fileiras: fileiraState })
    }
  },[setFormState, formState.fileiras, fileirasEdicao, estruturasOptions, fileiraState])

  const ajustaTipoEstrutura = (estruturas: any[]) => {
    const _formState = {...formState}
    const _isFiname = (_formState?.modulosList?.find(item => item.selecionado)?.finame && !["personalizado"]?.includes(_formState?.tipo || "")) || false
    const newFileiras = formState?.fileiras.map(item => item);
    newFileiras.forEach((item) => {
      const fileiraInvalida = (item as any).fileira_invalida || false;

      if (_isFiname && item?.tipo_estrutura && Number(item?.tipo_estrutura.value) === 0) {
          item.tipo_estrutura = null;
          return;
      }

      if (!_isFiname && item.tipo_estrutura  === null && !fileiraInvalida) {
        item.tipo_estrutura = {image: elSemEstrutura.url_imagem, text: elSemEstrutura.nome, value: elSemEstrutura.id};
      }

      if (!!item?.tipo_estrutura && fileiraInvalida) {
        item.tipo_estrutura = null;
      }

      if(item?.tipo_estrutura?.value){

        let _estruturasOptions = [];

        if (_isFiname) {
          _estruturasOptions = estruturas && estruturas.length && estruturas.length > 0 ? estruturas
            .filter(optItem => [item.posicao_modulo?.value, null, 'ambos'].includes(optItem.posicao) && optItem.status).filter(opItem => opItem.id !== 0)
            .map(item => ({ image: item.url_imagem, text: item.nome, value: item.id || "", estruturas_grupo_id: item?.estruturas_grupo_id })) : []
        }else{
          _estruturasOptions =  estruturas && estruturas.length && estruturas.length > 0 ? estruturas
          .filter(optItem => [item.posicao_modulo?.value, null, 'ambos'].includes(optItem.posicao) && optItem.status)
          .map(item => ({ image: item.url_imagem, text: item.nome, value: item.id || "", estruturas_grupo_id: item?.estruturas_grupo_id })) : []
        }

        if(_estruturasOptions && _estruturasOptions.length) {
          const idx = _estruturasOptions.findIndex((e: any) => e.value === item?.tipo_estrutura?.value && e.estruturas_grupo_id === item?.tipo_estrutura?.estruturas_grupo_id);
          if(idx < 0) {
            item.tipo_estrutura = null;
          }
        }
      }
      
    });
    setFormState({fileiras: newFileiras});
    setEstruturasAjustadas(true);
  }

  const buscarEstadoInicial = useCallback(async()=>{
    let exibirFraseParceiro = false;
    const currentRegioes = formState.regioes || []
    if (!currentRegioes.length) return;

    const regioesIds = currentRegioes.map((item: any) => item.id)
    const selected = formState?.modulosList?.find(item => item.selecionado)
    const sugestaoAnterior = formState.sugestoes?.modulo

    let qtdSugerida = 0
    if (selected) {
      if(selected?.exibir_popup_parceiro && !formState.isEdit) {
        setAlert(ALERT_POPUP_PARCEIRO);
      }

      const result = await projetosProvider.buscarQuantidadeDeModulos(selected.componente_id, formState.potencia_desejada, formState.segmento?.includes("on") ? "on" : "off")
      qtdSugerida = result.data.quantidade
      setFormState({ sugestoes: { ...formState.sugestoes, modulo: { id: selected.componente_id, quantidade: qtdSugerida, categoria_componentes_id: selected.categoria_componentes_id } } })
    }

    const res = await componentesProvider.buscarModulosPorRegiao(regioesIds, formState.potencia_desejada, undefined, formState?.tipo_inversor?.value, formState.tensao_rede?.value, formState.numero_fases?.value, formState.segmento?.includes("on") ? "on" : "off")

    const items: ModuloPorRegiaoListagemResponse[] = res || []
    
    setFormState({ modulosList: items ? items.map((modulo: ModuloPorRegiaoListagemResponse, index: number) => {
      const potencia = modulo.atributos.find(item => item.atributo === MODULO_POWER_ATTR)
      const savedItem = formState.modulosList ? formState.modulosList.find(item => item.componente_id === modulo.id) : null

      const hasMicroInversores = modulo.inversores.some((inversor) => inversor.categoria_componentes_id === ID_MICROINVERSOR)
      const hasString = modulo.inversores.some((inversor) => inversor.categoria_componentes_id === ID_INVERSOR)

      const inversoresTipos = []
      if (hasMicroInversores) inversoresTipos.push('microinversor')
      if (hasString) inversoresTipos.push('string')

      const potenciaMaxima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MAXIMA_ATTR)
      const potenciaMinima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MINIMA_ATTR)

      const getQuantidade = () => {
        if (!savedItem) return qtdSugerida || 0;
        if (savedItem?.componente_id !== sugestaoAnterior?.id) return savedItem.quantidade || 0;
        if (sugestaoAnterior?.quantidade !== qtdSugerida) return qtdSugerida;
        return savedItem.quantidade || 0
      }
      
      if(modulo.exibir_popup_parceiro && savedItem?.selecionado && exibirFraseParceiro === false) {
        exibirFraseParceiro = true;
      }

      return {
        potenciaMaxima: Number(potenciaMaxima?.valor || 0),
        potenciaMinima: Number(potenciaMinima?.valor || 0),
        componente_id: modulo.id,
        inversoresTipos: inversoresTipos,
        categoria_componentes_id: modulo.categoria_componentes_id,
        potencia: Number(potencia?.valor || 0),
        faturamento: modulo.data_previsao_faturamento ? new Date(modulo.data_previsao_faturamento).toISOString() : undefined,
        nome: modulo.nome,
        descricao: modulo.descricao,
        quantidade: getQuantidade(),
        selecionado: savedItem?.selecionado || false,
        categoria: modulo.categoria_componentes_nome,
        altura: modulo.altura,
        largura: modulo.largura,
        peso: modulo.peso,
        valor: 0, // Calculado no backend
        comprimento: modulo.comprimento,
        valor_unitario: savedItem?.valor_unitario || 0,
        regioes_parametros: modulo?.regioes_parametros,
        finame: modulo?.finame,
        exibir_popup_parceiro: modulo.exibir_popup_parceiro,
      }
    }) : []
    })

    if(exibirFraseParceiro && !formState.isEdit) {
      setAlert(ALERT_POPUP_PARCEIRO);
    }
  },[formState.regioes])

  useEffect(()=>{
    buscarEstadoInicial()
  },[buscarEstadoInicial])

  useEffect(() => {
    // iniciando intervalo de mensagens
    clearIntervalAlerts();
    startIntervalAlerts();
  }, []);

  const selectedModulo = useMemo(()=>{
    return formState.modulosList?.find(item => item.selecionado)
  },[formState.modulosList])

  const checarSePotenciaTotalMaiorQuePotenciaMaxima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMaxima: number; } =>{
    return potenciaTotalMaiorQuePotenciaMaxima(moduloSelecionado)
  },[selectedModulo])

  const checarSePotenciaTotalMenorQuePotenciaMinima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMinima: number; } =>{
    return potenciaTotalMenorQuePotenciaMinima(moduloSelecionado)
  },[selectedModulo])

  const checarPotenciaTotalEstaNoRangePotenciaRegiao = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; parametro: any; } =>{
    return checarParametroRegiaoPotencia(moduloSelecionado)
  },[selectedModulo])

  const isGreatherThanPowerLimitForCustomProjects = useCallback(()=>{
    const pot = selectedModulo?.potencia || 0
    const numModulos = selectedModulo?.quantidade || 0
    const powerInKw = (pot * numModulos) / 1000
    return powerInKw > POTENCIA_MINIMA_ENGENHARIA
  },[selectedModulo])

  const showMaxPowerNotify = useCallback(() => {
    stopIntervalAlerts();
    const state = { ...formState }
    redirecionarParaProjetoVertical({
      onNegation: () => {
        formState$.next({...resetarProjeto(state), ...NOVO_PROJETO_ENGENHARIA })
        history.replace('/projetos/verticais/novo',{ allowAccess: true })
      },
      yesText: 'Continuar dimensionando'
    })
  },[history, formState])

  const handleSelect = useCallback(async(id: number) => {
    const currentSelected = formState.modulosList?.find(item => item.selecionado)
    if (currentSelected?.componente_id === id) return;

    const qtdModulosResponse = await projetosProvider.buscarQuantidadeDeModulos(id, formState.potencia_desejada,  formState.segmento?.includes("on") ? "on" : "off")

    const newModulosList = formState.modulosList?.map((item) => {
      if (item.componente_id === id) {
        item.selecionado = true
        item.quantidade = qtdModulosResponse.data.quantidade
        setFraseParceiroPowerAlertFileiraList([]);
      } else {
        item.selecionado = false
      }
      return item
    })

    const currentSelectedNew = formState.modulosList?.find(item => item.selecionado)

    if(currentSelectedNew?.exibir_popup_parceiro) {
      setAlert(ALERT_POPUP_PARCEIRO);
      fraseParceiroPowerAlertList.push(id);
    }
    
    const isFiname = newModulosList?.find(item => item.selecionado)?.finame || false
    setProjetoFiname(isFiname);

    const novoModuloSelecionado = newModulosList?.find(item => item.selecionado);

    const _formState: Partial<Projeto> = {
      alterou_modulo: !!currentSelected,
      modulosList: newModulosList,
      fileiras: formState.fileiras.map(item => ({ ...item, tipo_estrutura: null })),
      sugestoes: {
        ...formState.sugestoes,
        modulo: {
          id, quantidade: qtdModulosResponse.data.quantidade || 0,
          categoria_componentes_id: novoModuloSelecionado?.categoria_componentes_id || 0
        }
      }
    }

    setFormState(_formState);

    if (novoModuloSelecionado?.regioes_parametros?.length) {
      const {status, parametro} = checarParametroRegiaoPotencia(novoModuloSelecionado);
      if (!status) mostrarParametroRegiaoPotenciaAlert(parametro?.potencia_inicial, parametro?.potencia_final);
    } else {
      // Verifica se o projeto ultrapassa o limite de potência
      const { potenciaMaxima, status: potenciaTotalMaiorQuePotenciaMaxima } = checarSePotenciaTotalMaiorQuePotenciaMaxima(novoModuloSelecionado)
      const { potenciaMinima, status: potenciaTotalMenorQuePotenciaMinima } = checarSePotenciaTotalMenorQuePotenciaMinima(novoModuloSelecionado)

      if (potenciaTotalMaiorQuePotenciaMaxima) {
        mostrarPotenciaTotalMaiorQuePotenciaMaximaAlert(potenciaMaxima)
      }
      if (potenciaTotalMenorQuePotenciaMinima) {
        mostrarPotenciaTotalMenorQuePotenciaMinimaAlert(potenciaMinima)
      }
    }

    const potencia = novoModuloSelecionado?.potencia || 0;
    const quantidde = novoModuloSelecionado?.quantidade || 1;
    const powerInKw = (potencia * quantidde) / 1000;
    if (powerInKw > POTENCIA_MINIMA_ENGENHARIA) {
      showMaxPowerNotify()
      return;
    }
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, isGreatherThanPowerLimitForCustomProjects, formState, setFormState, projetoFiname, setProjetoFiname])

  const handleChangeModuleQuantity = useCallback((id: number, value: string)=> {
    let _alertasList: TAlertsDom[] = alertsList$.getValue();
    const quantidade = Number(value || 0);

    const newModulosList = formState.modulosList?.map((item) => {
      if (item.componente_id === id) {
        if(item.exibir_popup_parceiro && formState.isEdit) {
          const idx = fraseParceiroPowerAlertList.findIndex(c => c === id);
          if(idx < 0 && quantidade > 0) {
            fraseParceiroPowerAlertList.push(id);
            _alertasList.push({
              alert: ALERT_POPUP_PARCEIRO,
            });
          } else {
            if(quantidade === 0) {
              fraseParceiroPowerAlertList.splice(idx, 1);
            }
          }
        }
        item.quantidade = quantidade
      }
      return item
    })
    
    setFormState({ modulosList: newModulosList, alterou_modulo: true })

    // Verifica se o projeto ultrapassa o limite de potência
    const canBeVertical = isGreatherThanPowerLimitForCustomProjects()
    const { potenciaMaxima, status: potenciaTotalMaiorQuePotenciaMaxima } = checarSePotenciaTotalMaiorQuePotenciaMaxima()
    const { potenciaMinima, status: potenciaTotalMenorQuePotenciaMinima } = checarSePotenciaTotalMenorQuePotenciaMinima()

    if (canBeVertical) {
      showMaxPowerNotify()
      return;
    }

    const novoModuloSelecionado = newModulosList?.find(item => item?.componente_id === id);
    if (novoModuloSelecionado?.regioes_parametros?.length) {
      const {status, parametro} = checarParametroRegiaoPotencia(novoModuloSelecionado);
      if (!status) {
        _alertasList.push({
          alert: ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA,
          data: {
            potencia_inicial: parametro?.potencia_inicial,
            potencia_final: parametro?.potencia_final,
          }
        });
        setAlertsList(_alertasList);
        return;
      }
    } else {
      if (potenciaTotalMaiorQuePotenciaMaxima) {
        _alertasList.push({
          alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
          data: {
            potencia_maxima: potenciaMaxima,
          }
        });
        setAlertsList(_alertasList);
        return;
      }
      if (potenciaTotalMenorQuePotenciaMinima) {
        _alertasList.push({
          alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
          data: {
            potencia_minima: potenciaMinima,
          }
        });
        setAlertsList(_alertasList);
        return;
      }
    }

    if(_alertasList && _alertasList.length) {
      setAlertsList(_alertasList);
    }
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, formState.modulosList, showMaxPowerNotify, isGreatherThanPowerLimitForCustomProjects, setFormState])

  const fileirasIsFilled = useCallback(()=>{
    const requiredFields: (keyof Fileira)[] = ['fileiras', 'posicao_modulo', 'quantidade_modulos', 'tipo_estrutura']
    return formState.fileiras.some(item => {
      return requiredFields.every(requiredField => {
        return item[requiredField]
      })
    })
  },[formState.fileiras])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = formState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[formState?.modulosList]);

  const potenciaInvalida = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_ENGENHARIA;
  },[potenciaTotal]);

  const nextButtonIsDisabled = useMemo(()=>{
    const temModulos = formState.modulosList?.some(item => item.quantidade > 0);
    if (!fileirasIsFilled()) return true;
    if (!formState.modulosList?.length) return true;
    if (!formState.fileiras.length) return true;
    if (modulosRestantes !== 0) return true;
    if (potenciaInvalida) return true;

    const possuiFileiraInvalida = formState.fileiras.some(item => (item as any).fileira_invalida)
    if (possuiFileiraInvalida) return true;
    
    if (selectedModulo?.regioes_parametros?.length) {
      if (checarPotenciaTotalEstaNoRangePotenciaRegiao().status === false) return true;
    } else {
      if (checarSePotenciaTotalMaiorQuePotenciaMaxima().status) return true;
      if (checarSePotenciaTotalMenorQuePotenciaMinima().status) return true;
    }

    if (!temModulos) return true;
    return false;
  },[selectedModulo, checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, checarPotenciaTotalEstaNoRangePotenciaRegiao, fileirasIsFilled, formState, formState?.modulosList, modulosRestantes, potenciaInvalida])

  useEffect(()=>{
    setDimensionadoTabDisabledStatus('inversores', nextButtonIsDisabled)
    setDimensionadoTabDoneStatus('modulos', !nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  const calcularEstrutura = useCallback(async() => {
    const selected = formState.modulosList?.find(item => item.selecionado)
    if (!selected) return;

    const filteredFileirasData = formState.fileiras.filter(item => {
      if (!item.fileiras) return false;
      if (!item.posicao_modulo?.value) return false
      if (!item.quantidade_modulos) return false;
      if (!item.tipo_estrutura?.value) return false
      return true
    })

    if (!filteredFileirasData.length) {
      setFormState({
        sugestoes: {
          ...formState.sugestoes,
          estrutura: [],
        },
        estrutura_calculadas: []
      })

      return;
    }

    const regioesIds = formState.regioes?.map((item: any) => item.id)

    const payload = {
      inversor: TIPO_INVERSOR_ID[formState.tipo_inversor?.value || 0],
      potencia: Number(potenciaGerador || 0),
      regiao_id: regioesIds,
      fileiras: filteredFileirasData.map(item => {
        const estruturaId = Number(item?.tipo_estrutura?.value)
        const rowsDisabled = checkRowsDisabled(estruturaId)
        return {
          estrutura_id: item.tipo_estrutura?.value || 0,
          fileiras_iguais: !rowsDisabled ? item.fileiras : 1,
          modulos_sequencia: item.quantidade_modulos,
          posicao: item.posicao_modulo?.value || 'paisagem',
          estruturas_grupo_id: item.tipo_estrutura?.estruturas_grupo_id || 0,
        }
      }),
      segmento: formState.segmento?.includes("on") ? "on" : "off"
    }

    const resultCalculoEstruturas = await projetosProvider.calcularEstrutura(selected.componente_id, payload)

    const estruturas = resultCalculoEstruturas.data || []

    setFormState({
      sugestoes: {
        ...formState.sugestoes,
        estrutura: estruturas.map(item => ({
          id: item.id,
          quantidade: item.quantidade,
          categoria_componentes_id: item.categoria_componentes_id,
          exibir_popup_parceiro: item.exibir_popup_parceiro,
        })),
      },
      estrutura_calculadas: estruturas.map(item => {
        return {
          altura: item.altura,
          categoria_componentes_id: item.categoria_componentes_id,
          componente_id: item.id,
          descricao: item.descricao,
          largura: item.largura,
          nome: item.nome,
          peso: item.peso,
          potencia: 0,
          quantidade: item.quantidade || 0,
          valor: 0,
          estruturas_grupo_id: item.estruturas_grupo_id,
          valor_unitario: 0,
          exibir_popup_parceiro: item.exibir_popup_parceiro,
        }
      }) })
  },[formState.sugestoes, setFormState, formState.modulosList, formState.fileiras, formState.regioes, formState.tipo_inversor?.value, formState.potencia_desejada, checkRowsDisabled])

  const renderModulos = useCallback(() => {

    if (isMobile) {
      return <ModulosListMobile 
        modulosList={formState?.modulosList || []}
        handleSelect={handleSelect}
        handleChangeModuleQuantity={handleChangeModuleQuantity}
        stringAvatarImg={stringAvatarImg}
        microinversorAvatarImg={microinversorAvatarImg}
        titulo="*Selecione o módulo desejado"
      />
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              <TableCell align='left'><strong>Selecione o módulo desejado</strong></TableCell>
              <TableCell align='right'><strong>Inversores disponíveis</strong></TableCell>
              <TableCell align='center'><strong>Qtde. Sugerida</strong></TableCell>
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formState.modulosList?.map((row) => (
              <TableRow key={row.componente_id}>
                <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                  <Box display='flex'>
                    <Radio className={classes.radioButton} value={row.componente_id} checked={row.selecionado} onClick={() => handleSelect(row.componente_id)} />
                  
                    <Box textAlign={'left'}>
                      <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                        {row.nome}
                      </Typography>
                      {row.descricao && (
                        <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}>Atenção</span>: {row.descricao}
                        </Typography>
                      )}
                      {row.faturamento && (
                        <Typography variant='body2' color='textSecondary'>
                          Previsão de faturamento: {Formater.toString(row.faturamento, TypeRecords.DATE)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  
                </TableCell>
                <TableCell align='right' component="th">
                  {row.inversoresTipos?.includes('string') && (
                    <Tooltip title='String'>
                      <img src={stringAvatarImg} alt='example'/>
                    </Tooltip>
                  )}
                  {row.inversoresTipos?.includes('microinversor') && (
                    <Tooltip title='Microinversor'>
                      <img src={microinversorAvatarImg} alt='example'/>
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell align='center' component="th">
                  <Box width="180px" margin={"0 auto"}>
                    {row.selecionado && (
                      <InputQuantidade value={row.quantidade} onChange={(v: any) => handleChangeModuleQuantity(row.componente_id, v)} />
                    )}
                  </Box>
                </TableCell>
                <TableCell align='center' component="th">
                  <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                    <IconButton
                      onClick={() => row.componente_id && modalComponentesDetalhesData$.next(row.componente_id)}
                      size="large">
                        <FindInPageOutlined htmlColor="black" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [classes, handleSelect, handleChangeModuleQuantity, formState.modulosList])

  const changePosicaoModulo = useCallback((index: number, field: keyof Fileira, value: any, atualizarEstrutura?: any)=>{
    const newFileiras = formState.fileiras.map((item, itemIndex) => {
      if (index === itemIndex) {
        if(atualizarEstrutura){
          return { ...item, [field]: value, tipo_estrutura: atualizarEstrutura}
        }
        if (atualizarEstrutura === null) {
          return { ...item, [field]: value, tipo_estrutura: atualizarEstrutura}
        }
        return { ...item, [field]: value}
      }      
      return item;
    });
    setFormState({ fileiras: newFileiras })
  }, [formState.fileiras, setFormState, estruturasOptions])

  const changeFileiras = useCallback((index: number, field: keyof Fileira, value: any)=>{
    const newFileiras = formState.fileiras.map((item, itemIndex) => {
      if (index === itemIndex) {
        // Reseta o campo "fileira_invalida" para false quando o valor do campo "fileiras" é alterado
        (item as any).fileira_invalida = false;
        return { ...item, [field]: value}
      }
      return item;
    });
    setFormState({ fileiras: newFileiras })
  },[formState.fileiras, setFormState, estruturasOptions])

  const popupParceiroFeleira = (index: number, value: number) => {
    const fileira = formState.fileiras[index];
    const idx = fraseParceiroPowerAlertFileiraList.findIndex(c => c === index);
    if(fileira?.tipo_estrutura?.exibir_popup_parceiro) {
        if(idx < 0 && value > 0) {
          showPopupParceiroPowerAlert(fraseParceiroPowerAlert.data);
          fraseParceiroPowerAlertFileiraList.push(index);
        } else {
          if(value === 0) {
            fraseParceiroPowerAlertFileiraList.splice(idx, 1);
          }
        }
    }
  }

  const handleNext = useCallback(()=>{
    calcularEstrutura().then(()=>{
      onClickNext()
    })
  },[onClickNext, calcularEstrutura])

  const resolveEstruturasOptions = useCallback((fileira: Fileira) => {
    const _formState = {...formState}
    const _isFiname = (_formState?.modulosList?.find(item => item.selecionado)?.finame && !["personalizado"]?.includes(_formState?.tipo || "")) || false
    if (_isFiname) {
      return estruturasOptions && estruturasOptions.length && estruturasOptions.length > 0 ? estruturasOptions
        .filter(optItem => [fileira.posicao_modulo?.value, null, 'ambos'].includes(optItem.posicao) && optItem.status).filter(opItem => opItem.id !== 0)
        .map(item => ({ image: item.url_imagem, text: item.nome, value: item.id || "", estruturas_grupo_id: item?.estruturas_grupo_id, exibir_popup_parceiro: item.exibir_popup_parceiro })) : []
    }
    return estruturasOptions && estruturasOptions.length && estruturasOptions.length > 0 ? estruturasOptions
      .filter(optItem => [fileira.posicao_modulo?.value, null, 'ambos'].includes(optItem.posicao) && optItem.status)
      .map(item => ({ image: item.url_imagem, text: item.nome, value: item.id || "", estruturas_grupo_id: item?.estruturas_grupo_id, exibir_popup_parceiro: item.exibir_popup_parceiro})) : []
  }, [estruturasOptions, formState?.modulosList])

  useEffect(() => {
    if (formState?.alterou_inversor && estruturasOptions?.length) {
      const newFileiras: any[] = formState?.fileiras?.map((item) => {
        const filterEstruturas = resolveEstruturasOptions(item);
        const ids = filterEstruturas?.map(estrutura => estrutura?.value);
        const grupos = filterEstruturas?.map(estrutura => estrutura?.estruturas_grupo_id || estrutura?.image);
        if (item?.tipo_estrutura && (!ids?.includes(item?.tipo_estrutura?.value) || !grupos?.includes(item?.tipo_estrutura?.estruturas_grupo_id || item?.tipo_estrutura?.image))) {
          return { ...item, tipo_estrutura: elSemEstrutura }
        }
        return item;
      }) || [];

      if (newFileiras?.length) setFormState({ fileiras: newFileiras });
    }
  }, [estruturasOptions, resolveEstruturasOptions, formState?.alterou_inversor])

  const fileiras = useMemo(() => {
    if (formState?.fileiras?.length) return formState.fileiras;
    if (formState?.fileiras_edicao?.length) return fileirasEdicao;
    return DEFAULT_PROJETO.fileiras;
  }, [formState, fileirasEdicao])

  const renderFileiras = useCallback(() => {
    return fileiras.map((item, index, list) => {
      const estruturaId = Number(item?.tipo_estrutura?.value)
      const rowsDisabled = checkRowsDisabled(estruturaId)
      return (
        <Box style={isMobile ? { marginBottom: 15 } : {} }>
          <Box mt={!isMobile ? 2 : 0} key={Number(index)} className="row">
            <Box className="X12 M6" style={isMobile ? {marginBottom: 25, marginTop: 20} : {}}>
              <SelectWithImageInOption
                id="custom-select-posicao-modulo"
                label="* Posição do módulo"
                onChange={async (d) => {
                  if (item?.posicao_modulo?.value !== d.value) {
                    let atualizarEstrutura = false;
                    if (d && item.tipo_estrutura) {
                      const estrutura: EstruturaListagemResponse | undefined = estruturasOptions.find((e: EstruturaListagemResponse) => e.id === item.tipo_estrutura?.value);
                      if (estrutura) {
                        if (estrutura.posicao !== d.value) {
                          atualizarEstrutura = true;
                        }
                      }
                    }

                    let _estrutura: any = null;

                    const _formState = {...formState}
                    const _isFiname = (_formState?.modulosList?.find(item => item.selecionado)?.finame && !["personalizado"]?.includes(_formState?.tipo || "")) || false

                    if (item.tipo_estrutura !== null && Number(item.tipo_estrutura.value) > 0) {
                      _estrutura = item.tipo_estrutura
                    }

                    if (!_isFiname) {
                      _estrutura = atualizarEstrutura ? {
                        image: SemEstrutura,
                        text: "Sem estrutura",
                        value: "",
                      } : null
                    }else{
                      _estrutura = null;
                    }

                    setTimeout(() => {
                      changePosicaoModulo(index, 'posicao_modulo', d, _estrutura);
                    }, 600)
                  }
                }}
                value={item.posicao_modulo}
                options={POSICAO_MODULO}
              />
            </Box>
            <Box className="X12 M6" style={isMobile ? {marginBottom: 10} : {}}>
              <SelectWithImageInOption
                id="custom-select-tipo-estrutura"
                label="* Tipo de estrutura"
                onChange={d => {
                  if(estruturasOptions && estruturasOptions.length && estruturasOptions.length > 0) {
                    const exibir_popup_parceiro = estruturasOptions.find((e: any) => e.id === d.value)?.exibir_popup_parceiro || false;
                    if(exibir_popup_parceiro) {
                      showPopupParceiroPowerAlert(fraseParceiroPowerAlert.data);
                      fraseParceiroPowerAlertFileiraList.push(index);
                    }
                  }
                  changeFileiras(index, 'tipo_estrutura', d);
                }}
                value={item.tipo_estrutura} 
                options={resolveEstruturasOptions(item)}
              />
            </Box>
          </Box>

          <Box className="row">
            <Box className="X12 M6">
              <InputDecimal3
                label={`* Módulos em sequência`}
                margin="normal"
                decimal={0}
                placeholder="0"
                allowNegative={false}
                value={item.quantidade_modulos || ''}
                onChange={(event: any) => {
                  changeFileiras(index, 'quantidade_modulos', event.target.value)
                  popupParceiroFeleira(index, event.target.value);
                }}
              />
            </Box>
            <Box className="X12 M6">
              {!rowsDisabled && (
                <InputDecimal3
                  label={`* Fileiras iguais`}
                  margin="normal"
                  decimal={0}
                  placeholder="0"
                  allowNegative={false}
                  disabled={rowsDisabled}
                  value={!rowsDisabled ? (item.fileiras || '') : 1}
                  onChange={(event: any) => {
                    changeFileiras(index, 'fileiras', event.target.value)
                    popupParceiroFeleira(index, event.target.value);
                  }}
                />
              )}
            </Box>
          </Box>

          {list.length > 1 && (
            <Box display="flex" justifyContent={"flex-end"} style={isMobile ? { marginTop: 15, marginBottom: 15 } : {}}>
              <Box width={isMobile ? "100%" : "auto"}>
                <Button variant="outlined" onClick={() => removeFileira(index)} className={classes.removeFileiraButton} disableElevation fullWidth={isMobile} startIcon={<Delete />}>
                  Excluir Fileira
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )
    })
  }, [removeFileira, changeFileiras, checkRowsDisabled, classes, estruturasOptions, formState.fileiras, projetoFiname, setProjetoFiname, formState.modulosList])

  const handleRestore = useCallback(() => {
    confirmationDialog.setup({
      title:'Atenção',
      content: (
        <>
          <Box mb={2}>
            <Typography>
              <strong>Restauração dos módulos</strong>
            </Typography>
          </Box>

          <Typography>Você tem certeza que deseja restaurar os módulos?</Typography>
        </>
      ),
      onConfirmation: () => {
        const moduloId = formState.sugestoes.modulo.id
        const newState = formState.modulosList?.map(item => {
          if(item.componente_id === moduloId) return { ...item,quantidade: formState.sugestoes.modulo.quantidade  }
          return item;
        })
        setFormState({ modulosList: newState })
      },
      onClose: () => confirmationDialog.close(),
      onNegation: () => confirmationDialog.close(),
      yesText: 'Restaurar',
      noText: 'Cancelar',
      submitButtonClassName: classes.restoreButtonConfirm
    })
    confirmationDialog.open()
  }, [classes, formState.sugestoes, formState.modulosList, setFormState])


  useEffect(() => {
    const _formState = { ...formState }
    const _isFiname = (_formState?.modulosList?.find(item => item.selecionado)?.finame && !["personalizado"]?.includes(_formState?.tipo || "")) || false
    setProjetoFiname(_isFiname)
  }, [formState])

  return (
    <LayoutProjetoDimensionado
      formState={formState}
      nextButtonIsDisabled={nextButtonIsDisabled}
      onClickBack={onClickBack}
      onClickNext={handleNext}
      title="Módulos"
      subtitle="Verifique as opções disponíveis. A quantidade será sugerida de acordo com o módulo selecionado e a potência do gerador definida anteriormente."
    >
      <Box p={2}>
        {renderModulos()}

        {isMobile && (
          <Box width={isMobile ? "100%" : "auto"}>
            <Tooltip title="Fique atento ao campo “módulos restantes” para estruturar o gerador. Não é possível adicionar fileiras quando não houverem mais módulos restantes.">
              <Button onClick={handleRestore} className={classes.addFileiraButton} variant="contained" disableElevation fullWidth={isMobile}>
                Restaurar Módulos
              </Button>
            </Tooltip>
          </Box>
        )}

        <Box my={2} width='100%' borderRadius="8px" bgcolor='#61616121' px={3} py={2} borderLeft={"10px solid #8BE68A"}>
          <Box display={"flex"} width="100%" justifyContent={"space-between"} flexDirection={isMobile? "column" : "row"}>
            <Typography variant='body2' color='textSecondary' align="left" style={isMobile ? {marginBottom: 5} : {}}>
              Metragem total de <strong>{metragemTotal.toLocaleString()} m²</strong>
            </Typography>
            <Typography variant='body2' color='textSecondary' align="left">
              Módulos restantes: <strong>{modulosRestantes >= 0 ? modulosRestantes : 0}</strong>
            </Typography>
          </Box>
        </Box>

        <Box my={4} style={isMobile ? { marginBottom: 5 } : {}}>
          <Typography align="left" variant="h6" color="textPrimary"><strong>Disposição dos módulos e fileiras:</strong></Typography>
        </Box>

        {renderFileiras()}
        {modulosRestantes !== 0 && (
          <small style={{ color: theme.palette.error.main, textAlign: 'start', display: 'block', marginBottom: isMobile ? 15 : 0 }}>Atenção! Configuração das fileiras incorreta. Por favor, corrija as disposições conforme a quantidade de módulos sugerida/escolhida.</small>
        )}

        <Box className="row" marginTop={isMobile ? '25px' : '5px'}>
          <Box py={2} borderRadius="8px" bgcolor='#61616121' borderLeft={"10px solid #8BE68A"} className="X12 M6" textAlign={'left'} padding={'10px'}>
            <span>Consulte o datasheet e manual do módulo para validar a necessidade de cabos e conectores adicionais para essa posição de instalação</span>
          </Box>
        </Box>

        <Box mt={2} display="flex" justifyContent={"flex-end"} flexDirection="column" alignItems={"flex-end"}>
          <Box my={2} width={isMobile ? "100%" : "auto"}>
            <Tooltip title="Fique atento ao campo “módulos restantes” para estruturar o gerador. Não é possível adicionar fileiras quando não houverem mais módulos restantes.">
              <Button disabled={modulosRestantes <= 0} onClick={addFileira} className={classes.addFileiraButton} variant="contained" disableElevation fullWidth={isMobile} startIcon={<Add />}>
                Adicionar Fileira
              </Button>
            </Tooltip>
          </Box>
          {!isMobile && (
            <Box width={isMobile ? "100%" : "auto"} style={isMobile ? { marginTop: 15 } : {}}>
              <Tooltip title="Fique atento ao campo “módulos restantes” para estruturar o gerador. Não é possível adicionar fileiras quando não houverem mais módulos restantes.">
                <Button onClick={handleRestore} className={classes.addFileiraButton} variant="contained" disableElevation fullWidth={isMobile}>
                  Restaurar Módulos
                </Button>
              </Tooltip>
            </Box>
          )}
        </Box>
      </Box>
    </LayoutProjetoDimensionado>
  );
}
export { Modulos }